import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import api from "../../api/axiosInstance";
const FormsShared = () => {
  const [sharedForms, setSharedForms] = useState([]);
const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
const userId = userData ? userData.id : null; // Get logged-in user email

  
  useEffect(() => {
    debugger;
    api
      .get(`/Form/GetFormsSharedWithMe?contactId=${userId}`)
      .then((res) =>
        {
          debugger;
setSharedForms(res.data);
        } )
      .catch((err) => console.error("Error fetching shared forms:", err));
  }, [userId]);

  const handleViewForm = (formId) => {
    window.open(`/form-preview/${formId}`, "_blank");
  };

   useEffect(() => {
      if (sharedForms.length > 0) {
        setTimeout(() => {
          if (window.$ && window.$.fn.DataTable) {
            window.$("#example1").DataTable({
              responsive: true,
              autoWidth: false,
              searching: true,
              ordering: true,
              pageLength: 10,
              lengthChange: false,
              paging: true,
              info: true,
              destroy: true, // Prevent duplication
            });
          }
        }, 300); // Slight delay to ensure table is in the DOM
      }
    }, [sharedForms]);


      const isValidDate = (date) => {
  if (!date) return false;
  const d = new Date(date);
  if (isNaN(d.getTime())) return false;
  if (d.getFullYear() <= 1) return false; // removes 0001-01-01
  return true;
};


  return (
    <div className="row">
    <div className="col-md-12">
      <div className="card card-success">
        <div className="card-header">
          <h3 className="card-title">🤝 Forms Shared With Me</h3>
        </div>
        <div className="card-body">
          <table id="example1" className="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="45%">Name</th>
                <th width="20%">Form Category</th>
                <th width="20%">Form Sub-Category</th>
                <th width="10%">Shared On</th>
                <th width="5%">Action</th>
              </tr>
            </thead>
            <tbody>
              {sharedForms.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", color: "gray" }}>
                    No Forms Available
                  </td>
                </tr>
              ) : (
                sharedForms.map((form) => (
                  <tr key={form.id}>
                    <td>{form.name}</td>
                    <td>{form.formCategoryName}</td>
                    <td>{form.formSubCategoryName}</td>
                    <td>{!isValidDate(form.createdOn) ?'': new Date(form.createdOn).toLocaleDateString()}</td>
                    <td>
                      {/* <Link to={`/editor/FormMastersView/${form.id}`} className="btn btn-xs btn-success" title="View">
                        <i className="fa fa-eye"></i>
                      </Link> */}
                      &nbsp;
                      <button
                        className="btn btn-xs btn-success"
                        title="Open in New Tab"
                        onClick={() => handleViewForm(form.id)}
                      >
                        <i className="fa fa-external-link-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
     </div>
  );
};

export default FormsShared;
